export const derivativeMarketIdMap: Record<
  string,
  { slug: string; ticker: string }
> = {
  //
}
